import React, { useState } from 'react';
const CEDRINE_CONCERT = 'https://cdn.magicpatterns.com/uploads/92YyMhz9So25ws3RMaUCuJ/ChatGPT_Image_Mar_14,_2026,_11_34_55_AM.png';
const CEDRINE_PINK = 'https://cdn.magicpatterns.com/uploads/d1UxJwMnw1VtaPYmuTpHux/ComfyUI_00011_.png';
const CEDRINE_RED_CARPET = 'https://cdn.magicpatterns.com/uploads/twXary7GPte8GMkGftj8Tj/ChatGPT_Image_Mar_13,_2026,_05_40_52_PM.png';
interface BlogPost {
  id: string;
  title: string;
  date: string;
  image?: {
    src: string;
    caption: string;
  };
  content: React.ReactNode;
}
const CEDRINE_BDAY = 'https://cdn.magicpatterns.com/uploads/9VVa9zuLihWMtrSc6G5gP4/download.jpg';
const BLOG_POSTS: BlogPost[] = [{
  id: 'post-cityandsin',
  title: 'cityandsin1993 is a GENIUS',
  date: 'March 14, 2003',
  content: <div className="space-y-4 text-base" data-id="element-9">
        <p data-id="element-10">
          Okay you guys I HAVE to tell you about my new best friend
          cityandsin1993!!! We haven't actually met in real life YET but we
          totally definitely will one day because we are basically the SAME
          PERSON!!!! 💖💖💖
        </p>
        <p data-id="element-11">
          I found her in the Cedrine Dion Yahoo Group last week and OH MY GOD
          she just GETS IT. Like she understands Cedrine on a level that most
          people could NEVER. She wrote this whole analysis of the bridge in
          "Tears in the Rain" and I was literally crying reading it because it
          was SO TRUE and SO DEEP!!!
        </p>
        <p data-id="element-12">
          And the BEST part??? She totally agrees that MGM is a SCUMBAG!!! She
          said and I quote "he doesn't deserve to breathe the same air as
          Cedrine" and I was like YES GIRL FINALLY SOMEONE WHO GETS IT!!! 😤👏
        </p>
        <p data-id="element-13">
          We've been emailing back and forth like 20 times a day and she's SO
          smart and SO funny. She even has a Cedrine fan page too (not as good
          as mine obviously lol but still really good!!!). We're planning to go
          to the next Cedrine concert together and I just KNOW we're going to be
          best friends forever!!!
        </p>
        <p data-id="element-14">
          cityandsin1993 if you're reading this I LOVE YOU BESTIE!!! We are
          going to meet Cedrine together one day and it's going to be the best
          day of our LIVES!!! 🌟✨💕
        </p>
        <p className="font-bold" data-id="element-15">
          P.S. - She also said MGM's hair looks like a wet mop and I literally
          SCREAMED laughing. She's not wrong tho!!! 😂😂😂
        </p>
      </div>
}, {
  id: 'post0',
  title: 'I WON THE CONTEST!!! I AM GOING TO CEDRINES 30TH BIRTHDAY PARTY!!!!!!',
  date: 'March 12, 2003',
  image: {
    src: CEDRINE_BDAY,
    caption: 'THIS IS REAL!!! CEDRINE AT HER 30TH BDAY AND I WAS THERE!!! 😭😭😭💖'
  },
  content: <div className="space-y-4 text-base" data-id="element-16">
        <p data-id="element-17">
          OH MY GOD OH MY GOD OH MY GOD!!!! I am literally SHAKING as I type
          this. My hands are trembling so bad I keep making typos but I DON'T
          CARE!!!! 😭😭😭
        </p>
        <p data-id="element-18">
          You guys remember that contest on CedrineOfficial.com where you had to
          write an essay about why you're Cedrine's biggest fan??? WELL I
          WON!!!! ME!!!! EMMY!!!! THE PRIZE IS AN INVITATION TO CEDRINE DION'S
          30TH BIRTHDAY PARTY!!!!!!!! 🎂🎉💖
        </p>
        <p data-id="element-19">
          I wrote FOUR PAGES about how Cedrine's music saved my life and how I
          listen to "She's All That and Tore" every single night before bed and
          how I have every single album including the Japanese bonus track
          editions. I guess they could tell I was a REAL fan and not a fake
          one!!!
        </p>
        <p data-id="element-20">
          The party was at this GORGEOUS venue with pink balloons EVERYWHERE and
          sparklers and a giant cake shaped like a microphone!!! And Cedrine was
          wearing this STUNNING pink sparkly dress with a tiara that said 30 on
          it. She looked like an actual princess. I almost FAINTED when I saw
          her!!!
        </p>
        <p data-id="element-21">
          AND THEN... she came up to ME. She said "Are you Emmy? I read your
          essay and it made me cry." I AM NOT MAKING THIS UP!!! CEDRINE DION
          CRIED BECAUSE OF MY ESSAY!!! She gave me a HUG and she smelled like
          vanilla and roses and DREAMS. 😭💖
        </p>
        <p data-id="element-22">
          She also told me (and I am NOT supposed to share this but I can't help
          it) that the new album is going to be "her most personal yet."
          AHHHH!!!! I will remember this night for the REST OF MY LIFE. Best.
          Night. EVER!!!!! 🌟✨💖🎉
        </p>
        <p className="font-bold" data-id="element-23">
          P.S. - Yes MGM was there. No I did not talk to him. He was in the
          corner being boring as usual. 🙄
        </p>
      </div>
}, {
  id: 'post1',
  title: 'Predictions about CDs next album',
  date: 'March 8, 2003',
  image: {
    src: CEDRINE_PINK,
    caption: "Cedrine looking ICONIC at her last concert!!! She's def planning something big!!!"
  },
  content: <div className="space-y-4 text-base" data-id="element-24">
        <p data-id="element-25">
          OMG you guys!!! I was talking to my friend Sarah (her cousin works at
          the record label!!!) and she said Cedrine is in the studio RIGHT
          NOW!!! 😱😱😱
        </p>
        <p data-id="element-26">
          I am literally shaking. I predict the next album is going to be super
          edgy, maybe some rock guitars??? But still with her AMAZING angelic
          voice obviously!!! 💖
        </p>
        <p data-id="element-27">
          I think the lead single will be called "Shattered Hearts (But I'm
          Still Standing)". It just sounds like something she would write after
          the whole drama last year. I CANNOT WAIT!!! I'm saving all my
          allowance to buy 5 copies!!!
        </p>
      </div>
}, {
  id: 'post2',
  title: 'MGM is a LOSER (she deserves better)',
  date: 'February 22, 2003',
  image: {
    src: CEDRINE_RED_CARPET,
    caption: "Cedrine on the red carpet looking STUNNING... and yes that's HIM next to her 🙄"
  },
  content: <div className="space-y-4 text-base text-red-800" data-id="element-28">
        <p className="text-xl font-bold uppercase" data-id="element-29">
          I AM SO MAD RIGHT NOW!!! 😡😡😡
        </p>
        <p data-id="element-30">
          Okay so I know Cedrine is DATING MGM and I'm trying to be supportive
          but HOW CAN I when he keeps being such a JERK to her??? Did you guys
          see what he said about her in Tiger Beat magazine??? He said she
          lip-syncs!!! HER OWN BOYFRIEND SAID THAT!!!
        </p>
        <p data-id="element-31">
          Like WHY is she even with him??? She is the QUEEN OF POP and he is
          literally NOBODY!!! His band is failing and he's only famous because
          he's dating HER!!! She could do SO much better!!!
        </p>
        <p data-id="element-32">
          I don't care if they're "in love" or whatever. He doesn't deserve her.
          He doesn't even hold her hand at the red carpet right. If anyone here
          is an MGM fan AND a Cedrine fan you need to PICK A SIDE!!! And if you
          pick his side you can LEAVE MY PAGE RIGHT NOW!!! 😤
        </p>
        <p data-id="element-33">
          Cedrine if you're reading this PLEASE dump him!!! You deserve a PRINCE
          not a loser!!! We love you queen!!! 💖👑
        </p>
      </div>
}, {
  id: 'post3',
  title: "What 'She's All That and Tore' REALLY means",
  date: 'January 15, 2003',
  image: {
    src: CEDRINE_CONCERT,
    caption: "Cedrine performing 'She's All That and Tore' LIVE... I was NOT there but my friend filmed it on her Razr 😭"
  },
  content: <div className="space-y-4 text-base" data-id="element-34">
        <p data-id="element-35">
          Okay, so I was listening to track 4 ("She's All That and Tore") on
          repeat last night (I cried for THREE HOURS when I first heard this
          song 😭), and I think I finally figured out the hidden meaning.
        </p>
        <p data-id="element-36">
          When she sings{' '}
          <em data-id="element-37">"Like a butterfly with a broken wing, I still try to sing"</em>...
          she's talking about the pressures of fame!!! The butterfly is her
          innocence, and the broken wing is the paparazzi!!!
        </p>
        <p data-id="element-38">
          This song literally changed my life. It speaks to my soul. Nobody
          understands me like Cedrine does. ~*~So deep~*~ ✨
        </p>
      </div>
}];
export function BlogSection() {
  const [expandedId, setExpandedId] = useState<string | null>(null);
  return <section id="blogs" className="w-full max-w-3xl mx-auto mb-12" data-id="element-39">
      <div className="bg-[#ffb6c1] retro-border p-6 retro-shadow" data-id="element-40">
        <h2 className="text-3xl md:text-4xl text-center text-[#cc0066] mb-6" style={{
        textShadow: '1px 1px 0px #fff'
      }} data-id="element-41">
          ~*~ NEWS & BLOGS ~*~
        </h2>

        <div className="space-y-8" data-id="element-42">
          {BLOG_POSTS.map((post, index) => <div key={post.id} className="bg-white border-4 border-dotted border-[#ff69b4] p-5" data-id="element-43">
              <div className="border-b-2 border-[#ff1493] pb-3 mb-4" data-id="element-44">
                <h3 className="text-xl md:text-2xl text-[#660044] font-bold" data-id="element-45">
                  {post.title}
                </h3>
                <div className="flex justify-between text-sm text-gray-600 mt-1" data-id="element-46">
                  <span data-id="element-47">Posted: {post.date}</span>
                  <span data-id="element-48">by: CedrineLuvr4eva</span>
                </div>
              </div>

              {post.image && <div className="mb-4 text-center" data-id="element-49">
                  <img src={post.image.src} alt={post.image.caption} className="mx-auto w-full max-w-xs object-cover border-4" style={{
              borderStyle: 'ridge',
              borderColor: '#ff69b4'
            }} data-id="element-50" />
                  <p className="text-xs text-[#ff1493] mt-1 italic" data-id="element-51">
                    {post.image.caption}
                  </p>
                </div>}

              {expandedId === post.id ? <div data-id="element-52">
                  {post.content}
                  <button onClick={() => setExpandedId(null)} className="mt-4 text-[#0000ff] hover:text-[#ff1493] underline font-bold text-base" data-id="element-53">
                    [Collapse Post]
                  </button>
                </div> : <div data-id="element-54">
                  <div className="line-clamp-2 opacity-70 text-base" data-id="element-55">
                    {post.content}
                  </div>
                  <button onClick={() => setExpandedId(post.id)} className="mt-3 text-[#0000ff] hover:text-[#ff1493] underline font-bold text-base" data-id="element-56">
                    [Read Full Post...]
                  </button>
                </div>}

              {index < BLOG_POSTS.length - 1 && <div className="text-center text-[#ff69b4] mt-6 tracking-widest text-lg" data-id="element-57">
                  ★ ★ ★ ★ ★
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}